import search from "@/services/search"
import events from "@/bl-events"

const state = {
  results: null,
  error: false,
  loading: false
}

const getters = {}

const mutations = {
  results: (state, payload) => {
    state.results = payload
  },
  error: (state) => {
    state.error = true
  },
  clearError: (state) => {
    state.error = false
  },
  startLoading: (state) => {
    state.loading = true
  },
  endLoading: (state) => {
    state.loading = false
  }
}

const actions = {
  reset: ({ commit }) => {
    commit("results", null)
    commit("endLoading")
    commit("clearError")
  },
  query: async ({ commit, dispatch, rootGetters }, payload) => {
    commit("startLoading")
    commit("clearError")

    try {
      await dispatch("content/ensureBlocklistIsPresent", null, { root: true })

      let results = await search(payload, {
        userLanguages: rootGetters.supportedLanguages,
        hasContentAccess: rootGetters.hasUserAccessToContent,
        blocklist: rootGetters["content/blocklist"]
      })

      if (results) {
        events.track("header-20200707-search", "2-trigger", `${results.length}-${payload}`)
        results = results.map((r, i) => {
          const searchParams = new URLSearchParams({ r: i + 1, st: payload })
          return {
            ...r,
            url: `${r.url}?${searchParams.toString()}`
          }
        })
      }
      commit("results", results)
    } catch (_) {
      commit("error")
    } finally {
      commit("endLoading")
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
